export enum RepaymentOptionType {
  ExtendTerm = "extend_term",
  CRHExtendTerm = "crh_extend_term",
  CRHWithoutExtendTerm = "crh_without_extend_term",
  CIRHExtendTerm = "cirh_extend_term",
  CIRHWithoutExtendTerm = "cirh_without_extend_term",
}

export const toRepaymentOptionType = (type: string): RepaymentOptionType => {
  const enumValues = Object.keys(RepaymentOptionType).map(
    (k) => RepaymentOptionType[k as keyof typeof RepaymentOptionType]
  );
  if (enumValues.findIndex((v) => v === type) >= 0) {
    return type as RepaymentOptionType;
  }
  throw new Error(`Unknown Repayment option type ${type}`);
};
export type ExistingLoanDetails = {
  monthlyRepaymentAmount: number;
  totalRepaymentAmount: number;
  interestRate: number;
  numberOfRepayments: number;
  remainingBalance: number;
  finalRepaymentDate: Date;
};
export type RepaymentOption = {
  optionType: RepaymentOptionType;
  newMonthlyRepayment: number;
  newTotalRepayment: number;
  newRemainingTerm: number;
  interestDuringHolidayTerm: number;
};

export type IndicativeRepaymentOptions = {
  existingLoanDetails: ExistingLoanDetails;
  repaymentOptions: RepaymentOption[];
};
export const findRepaymentOption =
  (repaymentOptions: RepaymentOption[]) =>
  (repaymentOptionType: RepaymentOptionType) =>
    repaymentOptions.find(
      (repaymentOption: RepaymentOption) =>
        repaymentOption.optionType === repaymentOptionType
    );

export const defaultExistingLoanDetails = (): ExistingLoanDetails => {
  return {
    monthlyRepaymentAmount: 0,
    totalRepaymentAmount: 0,
    interestRate: 0,
    numberOfRepayments: 0,
    remainingBalance: 0,
    finalRepaymentDate: new Date(),
  };
};
